import { render } from "./ProductScan.vue?vue&type=template&id=3a59c396&scoped=true"
import script from "./ProductScan.vue?vue&type=script&lang=js"
export * from "./ProductScan.vue?vue&type=script&lang=js"

import "./ProductScan.vue?vue&type=style&index=0&id=3a59c396&scoped=true&lang=css"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a59c396"]])

export default __exports__